/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Select, Space, TimePicker } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';
import LineTo from 'react-lineto';
import { useDispatch, useSelector } from 'react-redux';
import InputTag from '../../components/InputTag';
import * as SERVICE from '../../constants/service.types';
import regex from '../../constants/system.keys';
import { socketEmitEvent } from '../../redux/actions';
import DrawPolygon from '../DrawPolygon/DrawPolygon';
import DrawVirtualWall from '../DrawVirtualWall';
import './index.scss';

const { RangePicker } = TimePicker;

const FormCustom = ({
  data,
  spanLayout,
  dataSerial,
  formExpand,
  form,
  disabled,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { namespace, isAuth, accountByNamespace } = useSelector(
    (state) => state
  );
  const [widthVideo, setWidthVideo] = useState(0);
  const [heightVideo, setHeightVideo] = useState(0);
  const [checkError, setCheckError] = useState([]);
  const [dataRegion, setDataRegion] = useState('');
  const [dataWalls, setDataWalls] = useState([]);

  const [controlledPositionL, setControlledPositionL] = useState();
  const [controlledPositionR, setControlledPositionR] = useState();
  const [controlledPositionMidpoint, setControlledPositionMidpoint] =
    useState();
  const [keyDirectionIn, setKeyDirectionIn] = useState(Math.random());

  useEffect(() => {
    switch (data?.type) {
      case 'account': {
        getDeviceByPage();
        break;
      }
      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (
      data?.type === 'region' ||
      data?.type === 'directionIn' ||
      data?.type === 'chainpoint'
    ) {
      setWidthVideo(
        document?.getElementById('thumbnail-wrapper-id')?.offsetWidth ?? 0
      );
      setHeightVideo(
        document?.getElementById('thumbnail-wrapper-id')?.offsetHeight ?? 0
      );
    } else if (
      data?.type === 'period-minute' &&
      data?.field === 'periodRecognition'
    ) {
      const dataPeriodRecognition =
        (dataSerial?.service?.configuration &&
          JSON.parse(dataSerial?.service?.configuration)?.periodRecognition) ??
        data?.defaultValue ??
        [];
      const dataTemp =
        dataPeriodRecognition?.map((item) => ({
          rangeTime: [
            moment
              .utc()
              .hours(`${Math.floor(item?.fromTime / 60)}`)
              .minutes(
                `${item?.fromTime - Math.floor(item?.fromTime / 60) * 60}`
              ),
            moment
              .utc()
              .hours(`${Math.floor(item?.toTime / 60)}`)
              .minutes(`${item?.toTime - Math.floor(item?.toTime / 60) * 60}`),
          ],
        })) || [];
      formExpand?.setFieldsValue({ periodRecognition: dataTemp });
    } else if (data?.type === 'period-minute' && data?.field === 'timeUpload') {
      const dataTimeUpload =
        dataSerial?.configuration?.timeUpload ?? data?.defaultValue ?? [];
      const dataTemp =
        dataTimeUpload?.map((item) => ({
          rangeTime: [
            moment
              .utc()
              .hours(`${Math.floor(item?.fromTime / 60)}`)
              .minutes(
                `${item?.fromTime - Math.floor(item?.fromTime / 60) * 60}`
              ),
            moment
              .utc()
              .hours(`${Math.floor(item?.toTime / 60)}`)
              .minutes(`${item?.toTime - Math.floor(item?.toTime / 60) * 60}`),
          ],
        })) || [];
      form?.setFieldsValue({ timeUpload: dataTemp });
    }
  }, []);

  useEffect(() => {
    if (widthVideo > 0 && heightVideo > 0 && data?.type === 'region') {
      if (
        dataSerial?.service?.configuration &&
        JSON.parse(dataSerial?.service?.configuration)?.region
      ) {
        const dataRegion =
          dataSerial?.service?.configuration &&
          JSON.parse(dataSerial?.service?.configuration)?.region;
        setDataRegion(dataRegion);
      } else {
        setDataRegion(`0,0;1,0;1,1;0,1`);
      }
    }

    if (widthVideo > 0 && heightVideo > 0 && data?.type === 'chainpoint') {
      if (
        dataSerial?.service?.configuration &&
        JSON.parse(dataSerial?.service?.configuration)?.chainpoints
      ) {
        const walls =
          JSON.parse(
            JSON.parse(dataSerial?.service?.configuration)?.chainpoints
          ) || [];
        setDataWalls(walls);
      } else {
        setDataWalls([]);
      }
    }

    if (widthVideo > 0 && heightVideo > 0 && data?.type === 'directionIn') {
      if (
        dataSerial?.service?.configuration &&
        JSON.parse(dataSerial?.service?.configuration)?.directionIn
      ) {
        const dataDirectionIn =
          dataSerial?.service?.configuration &&
          JSON.parse(dataSerial?.service?.configuration)?.directionIn;
        const dataR = {
          x: Math.round(
            (dataDirectionIn?.split(';')?.[0]?.split(',')?.[0] ?? 0) *
              widthVideo
          ),
          y: Math.round(
            (dataDirectionIn?.split(';')?.[0]?.split(',')?.[1] ?? 0) *
              heightVideo
          ),
        };
        const dataM = {
          x: Math.round(
            (dataDirectionIn?.split(';')?.[1]?.split(',')?.[0] ?? 0) *
              widthVideo
          ),
          y: Math.round(
            (dataDirectionIn?.split(';')?.[1]?.split(',')?.[1] ?? 0) *
              heightVideo
          ),
        };
        setControlledPositionR(dataR);
        setControlledPositionMidpoint(dataM);
        setControlledPositionL({
          x: dataM.x - (dataR.x - dataM.x),
          y: dataM.y - (dataR.y - dataM.y),
        });
        setTimeout(() => {
          setKeyDirectionIn(Math.random());
        }, 1);
      } else {
        setControlledPositionL({
          x: Number((widthVideo / 4).toFixed(0)),
          y: Number((heightVideo / 2).toFixed(0)),
        });
        setControlledPositionR({
          x: Number(((widthVideo * 3) / 4).toFixed(0)),
          y: Number((heightVideo / 2).toFixed(0)),
        });
        setControlledPositionMidpoint({
          x: Number((widthVideo / 2).toFixed(0)),
          y: Number((heightVideo / 2).toFixed(0)),
        });

        setTimeout(() => {
          setKeyDirectionIn(Math.random());
        }, 1);
        formExpand?.setFieldsValue({
          directionIn: '0.75,0.5;0.5,0.5',
        });
      }
    }
  }, [widthVideo, heightVideo]);

    const handleChangeWalls = (newWalls) => {
    formExpand?.setFieldsValue({ chainpoints: JSON.stringify(newWalls) });
  };

  const onUpdateRegion = useCallback(
    (newDataRegion) => {
      if (namespace) {
        formExpand?.setFieldsValue({ region: newDataRegion });
      }
    },
    [widthVideo, heightVideo, namespace, dispatch]
  );

  const getDeviceByPage = useCallback(() => {
    if (isAuth === 1 && namespace) {
      let dataTemp = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataTemp),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  const onChangeRangerDate = (dataField) => {
    const data =
      formExpand?.getFieldValue(dataField) ?? form?.getFieldValue(dataField);
    if (data?.length > 1) {
      let dataTemp = [...checkError];
      data.map((item, index) => {
        if (index === 0 && item?.rangeTime && data[index + 1]?.rangeTime) {
          if (
            moment(item?.rangeTime?.[1]).hour() * 60 +
              moment(item?.rangeTime?.[1]).minute() >
            moment(data[index + 1]?.rangeTime?.[0]).hour() * 60 +
              moment(data[index + 1]?.rangeTime?.[0]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else {
            dataTemp = dataTemp.filter((item) => item !== index);
          }
        }
        if (
          index === data?.length - 1 &&
          item?.rangeTime &&
          data[index - 1]?.rangeTime
        ) {
          if (
            moment(item?.rangeTime?.[0]).hour() * 60 +
              moment(item?.rangeTime?.[0]).minute() <
            moment(data[index - 1]?.rangeTime?.[1]).hour() * 60 +
              moment(data[index - 1]?.rangeTime?.[1]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else {
            dataTemp = dataTemp.filter((item) => item !== index);
          }
        }
        if (
          index > 0 &&
          index < data?.length - 1 &&
          item?.rangeTime &&
          data[index + 1]?.rangeTime &&
          data[index - 1]?.rangeTime
        ) {
          if (
            moment(item?.rangeTime?.[1]).hour() * 60 +
              moment(item?.rangeTime?.[1]).minute() >
            moment(data[index + 1]?.rangeTime?.[0]).hour() * 60 +
              moment(data[index + 1]?.rangeTime?.[0]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else if (
            moment(item?.rangeTime?.[0]).hour() * 60 +
              moment(item?.rangeTime?.[0]).minute() <
            moment(data[index - 1]?.rangeTime?.[1]).hour() * 60 +
              moment(data[index - 1]?.rangeTime?.[1]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else {
            dataTemp = dataTemp.filter((item) => item !== index);
          }
        }
      });
      setCheckError([...dataTemp]);
    }
  };

  const onChangeRangerRemove = (dataCheckError, dataField) => {
    const data =
      formExpand?.getFieldValue(dataField) ?? form?.getFieldValue(dataField);
    if (data?.length > 1) {
      let dataTemp = [...dataCheckError];
      data.map((item, index) => {
        if (index === 0) {
          if (
            moment(item?.rangeTime?.[1]).hour() * 60 +
              moment(item?.rangeTime?.[1]).minute() >
            moment(data[index + 1]?.rangeTime?.[0]).hour() * 60 +
              moment(data[index + 1]?.rangeTime?.[0]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else {
            dataTemp = dataTemp.filter((item) => item !== index);
          }
        }
        if (index === data?.length - 1) {
          if (
            moment(item?.rangeTime?.[0]).hour() * 60 +
              moment(item?.rangeTime?.[0]).minute() <
            moment(data[index - 1]?.rangeTime?.[1]).hour() * 60 +
              moment(data[index - 1]?.rangeTime?.[1]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else {
            dataTemp = dataTemp.filter((item) => item !== index);
          }
        }
        if (index > 0 && index < data?.length - 1 && data?.length > 3) {
          if (
            moment(item?.rangeTime?.[1]).hour() * 60 +
              moment(item?.rangeTime?.[1]).minute() >
            moment(data[index + 1]?.rangeTime?.[0]).hour() * 60 +
              moment(data[index + 1]?.rangeTime?.[0]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else if (
            moment(item?.rangeTime?.[0]).hour() * 60 +
              moment(item?.rangeTime?.[0]).minute() <
            moment(data[index - 1]?.rangeTime?.[1]).hour() * 60 +
              moment(data[index - 1]?.rangeTime?.[1]).minute()
          ) {
            dataTemp = [...dataTemp, index];
          } else {
            dataTemp = dataTemp.filter((item) => item !== index);
          }
        }
      });
      setCheckError([...dataTemp]);
    }
  };

  const onControlledDragL = (e, position) => {
    const { x, y } = position;
    const dataR = {
      x: controlledPositionMidpoint.x - (x - controlledPositionMidpoint.x),
      y: controlledPositionMidpoint.y - (y - controlledPositionMidpoint.y),
    };
    if (
      x >= 0 &&
      y >= 0 &&
      x <= widthVideo &&
      y <= heightVideo &&
      dataR.x >= 0 &&
      dataR.y >= 0 &&
      dataR.x <= widthVideo &&
      dataR.y <= heightVideo
    ) {
      setControlledPositionL({ x, y });
      setControlledPositionR(dataR);
      formExpand?.setFieldsValue({
        directionIn: `${`${(dataR.x / widthVideo).toFixed(2)},${(
          dataR.y / heightVideo
        ).toFixed(2)}`};${`${(
          controlledPositionMidpoint.x / widthVideo
        ).toFixed(2)},${(controlledPositionMidpoint.y / heightVideo).toFixed(
          2
        )}`}`,
      });
    }
  };

  const onControlledDragR = (e, position) => {
    const { x, y } = position;
    const dataL = {
      x: controlledPositionMidpoint.x - (x - controlledPositionMidpoint.x),
      y: controlledPositionMidpoint.y - (y - controlledPositionMidpoint.y),
    };
    if (
      x >= 0 &&
      y >= 0 &&
      x <= widthVideo &&
      y <= heightVideo &&
      dataL.x >= 0 &&
      dataL.y >= 0 &&
      dataL.x <= widthVideo &&
      dataL.y <= heightVideo
    ) {
      setControlledPositionR({ x, y });
      setControlledPositionL(dataL);
      formExpand?.setFieldsValue({
        directionIn: `${`${(x / widthVideo).toFixed(2)},${(
          y / heightVideo
        ).toFixed(2)}`};${`${(
          controlledPositionMidpoint.x / widthVideo
        ).toFixed(2)},${(controlledPositionMidpoint.y / heightVideo).toFixed(
          2
        )}`}`,
      });
    }
  };

  const onControlledDragMidpoint = (e, position) => {
    const newRPositionX = controlledPositionR.x + position.deltaX;
    const newRPositionY = controlledPositionR.y + position.deltaY;
    const newLPositionX = controlledPositionL.x + position.deltaX;
    const newLPositionY = controlledPositionL.y + position.deltaY;
    if (
      newRPositionX >= 0 &&
      newRPositionY >= 0 &&
      newRPositionX <= widthVideo - 15 &&
      newRPositionY <= heightVideo - 15 &&
      newLPositionX >= 0 &&
      newLPositionY >= 0 &&
      newLPositionX <= widthVideo - 15 &&
      newLPositionY <= heightVideo - 15
    ) {
      getHalfwayPoint(
        {
          x: newLPositionX,
          y: newLPositionY,
        },
        {
          x: newRPositionX,
          y: newRPositionY,
        }
      );
      setControlledPositionL({
        x: newLPositionX,
        y: newLPositionY,
      });
      setControlledPositionR({
        x: newRPositionX,
        y: newRPositionY,
      });
      formExpand?.setFieldsValue({
        directionIn: `${`${(newRPositionX / widthVideo).toFixed(2)},${(
          newRPositionY / heightVideo
        ).toFixed(2)}`};${`${(
          (newLPositionX + newRPositionX) /
          2 /
          widthVideo
        ).toFixed(2)},${(
          (newLPositionY + newRPositionY) /
          2 /
          heightVideo
        ).toFixed(2)}`}`,
      });
    }
  };

  const getHalfwayPoint = (dataL, dataR) => {
    let newX = (dataR.x + dataL.x) / 2;
    let newY = (dataR.y + dataL.y) / 2;
    setControlledPositionMidpoint({ x: newX, y: newY });
  };

  switch (data?.type) {
    case 'text': {
      if (data?.isMore === 1) {
        return (
          <Col span={spanLayout}>
            <Form.Item
              className="add-imput-tag"
              style={{ width: '100%' }}
              label={data.fieldDisplay}
              name={data.field}
            >
              <InputTag
                numberTag={5}
                disabled={disabled}
                nameAdd="Add IP Address"
              />
            </Form.Item>
          </Col>
        );
      } else {
        return (
          <Col span={spanLayout}>
            <Form.Item
              style={{ width: '100%' }}
              label={data.fieldDisplay}
              name={data.field}
              rules={[
                {
                  required: true,
                  message: `Please enter the ${data.fieldDisplay}!`,
                },
                {
                  pattern: regex.isText,
                  message: `Please enter the ${data.fieldDisplay}!`,
                },
                {
                  max: data.length,
                  message: `Please enter up to ${data.length} characters!`,
                },
              ]}
            >
              <Input
                disabled={disabled}
                allowClear
                placeholder={data.fieldDisplay}
              />
            </Form.Item>
          </Col>
        );
      }
    }

    case 'region': {
      return (
        <Col span={spanLayout}>
          <style>
            {`
            .single-resizer {
              border: ${disabled ? '1px solid #9e9e9e' : '1px solid #eb5648'};
            }
            .single-resizer .square {
              background: ${disabled ? '#9e9e9e' : 'white'};
              border: ${disabled ? '1px solid #9e9e9e' : '1px solid #eb5648'};
            }
            `}
          </style>
          <Form.Item
            style={{ width: '100%', height: '36vh' }}
            label={data.fieldDisplay}
            name={data.field}
          >
            <div
              className="thumbnail-wrapper thumbnail"
              id="thumbnail-wrapper-id"
            >
              <div style={{ marginTop: '40px', marginLeft: '10px' }}>
                <DrawPolygon
                  width={widthVideo}
                  height={heightVideo}
                  strPoints={dataRegion}
                  bgImage={
                    dataSerial?.thumbnail && dataSerial?.thumbnail !== 'NULL'
                      ? dataSerial?.thumbnail
                      : 'https://s2.beex.vn/image/p1/8Q886M135K6r/thumbnail/8Q886M135K6r.jpg'
                  }
                  onChange={(result) => {
                    onUpdateRegion(result);
                  }}
                  disabled={disabled}
                />
              </div>
            </div>
          </Form.Item>
        </Col>
      );
    }

    case 'chainpoint': {
      return (
        <Col span={spanLayout}>
          <Form.Item
            style={{ width: '100%', height: '36vh' }}
            name={data.field}
          >
            <div
              className="thumbnail-wrapper thumbnail"
              id="thumbnail-wrapper-id"
            >
              <DrawVirtualWall
                width={widthVideo}
                height={heightVideo}
                bgImage={
                  dataSerial?.thumbnail && dataSerial?.thumbnail !== 'NULL'
                    ? dataSerial?.thumbnail
                    : 'https://s2.beex.vn/image/p1/8Q886M135K6r/thumbnail/8Q886M135K6r.jpg'
                }
                virtualWalls={dataWalls}
                onChange={(newWalls) => handleChangeWalls(newWalls)}
                disabled={disabled}
              />
            </div>
          </Form.Item>
        </Col>
      );
    }

    case 'account': {
      return (
        <Col span={spanLayout}>
          <Form.Item
            style={{ width: '100%' }}
            label={data.fieldDisplay}
            name={data.field}
            rules={[
              {
                required: true,
                message: `Please select the ${data.fieldDisplay}!`,
              },
            ]}
          >
            <Select
              disabled={disabled}
              showSearch
              placeholder={data.fieldDisplay}
              optionFilterProp="children"
            >
              {accountByNamespace?.map((d) => (
                <Select.Option key={d.accountId}>
                  {d.fullName
                    ? `${d.phonenumber} (${d.fullName})`
                    : d.phonenumber}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      );
    }

    case 'integer': {
      return (
        <Col span={spanLayout}>
          <Form.Item
            style={{ width: '100%' }}
            label={data.fieldDisplay}
            name={data.field}
            rules={[
              {
                required: true,
                message: `Please enter the ${data.fieldDisplay}!`,
              },
              {
                max: data.length,
                message: `Please enter up to ${data.length} characters!`,
              },
            ]}
          >
            <Input
              disabled={disabled}
              type="number"
              placeholder={data.fieldDisplay}
            />
          </Form.Item>
        </Col>
      );
    }

    case 'period-minute': {
      return (
        <Col span={spanLayout} className="period-minute">
          <Form.List name={data.field} style={{ width: '100%' }}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <Space
                    key={key}
                    style={{ display: 'flex', width: '100%' }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      style={{ width: '100%' }}
                      name={[name, 'rangeTime']}
                      fieldKey={[fieldKey, 'rangeTime']}
                      rules={[
                        {
                          required: true,
                          message: `Please select the ${data.fieldDisplay}!`,
                        },
                      ]}
                    >
                      <RangePicker
                        disabled={disabled}
                        placeholder={['Từ', 'Đến']}
                        style={{ width: '100%' }}
                        format="HH:mm"
                        onChange={() => onChangeRangerDate(data.field)}
                      />
                    </Form.Item>
                    <MinusCircleOutlined
                      onClick={() => {
                        if (!disabled) {
                          remove(name);
                          onChangeRangerRemove(
                            checkError.filter((item) => item !== name),
                            data.field
                          );
                        }
                      }}
                    />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    disabled={disabled}
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                  >
                    Add period
                  </Button>
                </Form.Item>
                {checkError?.length > 0 && (
                  <div
                    style={{
                      color: '#a61d24',
                      marginTop: '-20px',
                      marginBottom: '10px',
                    }}
                  >
                    {t('Please select non-conflicting time period!')}
                  </div>
                )}
              </>
            )}
          </Form.List>
        </Col>
      );
    }

    case 'directionIn': {
      return (
        <Col span={spanLayout}>
          <style>
            {`
            .direction-mid-point {
              border-top: ${
                disabled
                  ? '2px solid #9e9e9e !important'
                  : '2px solid #eb5648 !important'
              };
            }
            .thumbnail-wrapper .thumbnail-frame .overlay .dot {
              background: ${
                disabled ? '#9e9e9e !important' : '#eb5648 !important'
              };
              border: ${
                disabled
                  ? '1px solid #9e9e9e !important'
                  : '1px solid #eb5648 !important'
              };
            }
            `}
          </style>
          <Form.Item
            style={{ width: '100%', height: '36vh' }}
            label={data.fieldDisplay}
            name={data.field}
          >
            <div
              className="thumbnail-wrapper thumbnail"
              id="thumbnail-wrapper-id"
            >
              <div className="thumbnail-frame">
                {controlledPositionL &&
                  controlledPositionR &&
                  controlledPositionMidpoint && (
                    <div className="overlay" key={keyDirectionIn}>
                      <Draggable
                        position={controlledPositionL}
                        onDrag={onControlledDragL}
                        bounds="parent"
                        disabled={disabled}
                      >
                        <span className="dot A">
                          <span
                            style={{
                              color: disabled ? '#9e9e9e' : '#eb5648',
                              margin: '-20px',
                              marginLeft: '-10px',
                              display: 'block',
                              fontWeight: 'bold',
                            }}
                          >
                            {t('OUT')}
                          </span>
                        </span>
                      </Draggable>

                      <Draggable
                        position={controlledPositionR}
                        onDrag={onControlledDragR}
                        bounds="parent"
                        disabled={disabled}
                      >
                        <span className="dot B">
                          <span
                            style={{
                              color: disabled ? '#9e9e9e' : '#eb5648',
                              margin: '-20px',
                              marginLeft: '-2px',
                              display: 'block',
                              fontWeight: 'bold',
                            }}
                          >
                            {t('IN')}
                          </span>
                        </span>
                      </Draggable>

                      <Draggable
                        position={controlledPositionMidpoint}
                        onDrag={onControlledDragMidpoint}
                        bounds="parent"
                        disabled={disabled}
                      >
                        <span className="dot C" />
                      </Draggable>
                      <LineTo className="direction-mid-point" from="A" to="B" />
                    </div>
                  )}
              </div>
              <img
                src={
                  dataSerial?.thumbnail && dataSerial?.thumbnail !== 'NULL'
                    ? dataSerial?.thumbnail
                    : 'https://s2.beex.vn/image/p1/8Q886M135K6r/thumbnail/8Q886M135K6r.jpg'
                }
                alt="thumbnail"
              />
            </div>
          </Form.Item>
        </Col>
      );
    }

    default:
      return null;
  }
};

export default FormCustom;
